<script setup>

import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import SolicitaRevisaoConteudo from "./SolicitaRevisaoConteudo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "solicitandoRevisao",
    "controlesDesativados",
    "pedidoDeCompra"
]);

const emits = defineEmits([
    "update:solicitandoRevisao",
    "update:controlesDesativados"
]);

//==================================================================//
//========================= Justificativa ==========================//
//==================================================================//

const justificativa = ref("");

//==================================================================//
//================== Altera Solicitando Revisao ====================//
//==================================================================//

const alteraSolicitandoRevisao = (update) =>{

    emits('update:solicitandoRevisao',update);

};

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:controlesDesativados',update);

};

//==================================================================//
//===================== Altera Justificativa =======================//
//==================================================================//

const alteraJustificativa = (update) =>{

    justificativa.value = update.justificativa;
}

//==================================================================//
//============== Preenche com Justificativa Padrao =================//
//==================================================================//

const preencheComJustificativaPadrao = () =>{

    alteraJustificativa({
        observacao: "",
    });

}

//==================================================================//
//============================= Watch ==============================//
//==================================================================//

watch(()=> props.solicitandoRevisao, () => {

    preencheComJustificativaPadrao("");

});

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.solicitandoRevisao"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card
                class="c-modal"
                :class="{ 'c-modal--disabled': props.controlesDesativados }"
            >

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :controlesDesativados="props.controlesDesativados"
                    :pedidoDeCompra="props.pedidoDeCompra"
                    :justificativa="justificativa"
                    :solicitandoRevisao="props.solicitandoRevisao"
                    @update:solicitandoRevisao="alteraSolicitandoRevisao"
                    @update:controlesDesativados="alteraControlesDesativados"
                >
                </BarraNavegacao>

                <SolicitaRevisaoConteudo
                    :pedidoDeCompra="pedidoDeCompra"
                    :justificativa="justificativa"
                    :controlesDesativados="controlesDesativados"
                    @update:justificativa="alteraJustificativa"
                >
                </SolicitaRevisaoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

.c-modal--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>

